import { defineStore } from "pinia";
import { ref } from "vue";

export const useCommunicationStore = defineStore("connectionStore", () => {
  const callbacks = ref<any>([]);

  const registerCallback = (callback: any) => {
    if (typeof callback === "function") {
      callbacks.value.push(callback);
    }
  };

  const unregisterCallback = (callback: any) => {
    callbacks.value = callbacks.value.filter((cb: any) => cb !== callback);
  };

  const sendValue = (value: any) => {
    callbacks.value.forEach((callback: any) => {
      try {
        callback(value);
      } catch (error) {
        console.error("Error in callback:", error);
      }
    });
  };

  return {
    sendValue,
    registerCallback,
    unregisterCallback,
  };
});